var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/ConfigVersionMessage.tsx";
import React, { useMemo, useState } from 'react';
import { _config } from 'Utilities/envConfig';
import i18n from 'Utilities/i18n';
import { getSessionObject, setSessionObject } from 'Utilities/storage';
const ConfigVersionMessage = () => {
  const closeIcon = i18n.t('Global.microcopy.common.iconClose');
  const [disabled, setDisabled] = useState(getSessionObject('ignoreVersion') === true);
  const ignore = () => {
    setSessionObject('ignoreVersion', true);
    setDisabled(true);
  };

  /**
   * This method will create a string that is used for regulatory reason to show clearly the
   * current environment
   */
  const message = useMemo(() => {
    if (disabled) {
      return null;
    }
    if (_config.production) {
      return null;
    }
    let string = `Version (${process.env.VERSION})${_config.environment ? `[${_config.environment}]` : ''}`;
    if (_config.mock) {
      string += ' - MOCK';
    }
    return string;
  }, [disabled]);
  return message ? /*#__PURE__*/React.createElement("div", {
    id: "__VERSION_DEBUG_INFO",
    className: "d-flex align-items-center font-weight-bold line-height-normal min-width-0 h-100",
    style: {
      flexShrink: 10000,
      overflow: 'hidden'
    } // Make debug text shrink before anything else
    ,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("button", {
    id: "__VERSION_DEBUG_DISMISS_BUTTON",
    className: "btn btn-info btn-sm btn-round mx-1",
    onClick: ignore,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: closeIcon,
    alt: "",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement("span", {
    className: "pr-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 7
    }
  }, message)) : null;
};
export default ConfigVersionMessage;